<template>
  <section>
    <div class="row">
      <div class="col col-lg-12 px-lg-12 py-lg-12">
        <div v-if="relatori.person">
        <!-- <div v-if="true"> -->
          <div class="form-row">
              <label class="range-label" for="years-range">Intervallo Di Annate</label>
              <div
              class="form-group col-lg-12 px-lg-12 py-lg-12"
              id="year-form-group">
              <vue-slider
                id="years-range"
                ref="yearsRange"
                :value="defaultYearsRange"
                :min="minYear"
                :max="maxYear"
                :enable-cross="false"
                :contained="true"
                :tooltip="'always'"
                :tooltip-placement="'bottom'"
                @drag-end="selectYears()">
              </vue-slider>
            </div>
          </div>
          <!-- <div class="form-row">
            <div class="form-group col-lg-12 px-lg-12 py-lg-12">
              <div class="input-group">
                <label for="numero-pronuncia" class="numero-pronuncia-label">Numero Pronuncia</label>
                <span class="input-number">
                  <input
                    type="number"
                    id="numero-pronuncia"
                    name="numero-pronuncia" placeholder="Numero Pronuncia">
                </span>
                <span class="autocomplete-icon" aria-hidden="true">
                  <div class="input-group-append">
                    <svg class="icon">
                      <use :xlink:href="icons.itFile"></use>
                    </svg>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-lg-12 px-lg-12 py-lg-12">
              <div class="input-group">
                <input
                  type="text"
                  id="ecli-pronuncia"
                  name="ecli-pronuncia" placeholder="ECLI Pronuncia">
                <span class="autocomplete-icon" aria-hidden="true">
                  <div class="input-group-append">
                    <svg class="icon">
                      <use :xlink:href="icons.itFile"></use>
                    </svg>
                  </div>
                </span>
              </div>
            </div>
          </div> -->
          <div class="form-row">
            <div
              class="chip presidente-bg"
              v-for="(president, $index) in filters.presidents" :key="$index">
                <span class="chip-label text-white"><em>presidente</em>: {{president}}</span>
                <button @click="deleteFilter('presidents', $index)">
                  <svg class="icon white"><use :xlink:href="icons.itClose"></use></svg>
                  <span class="sr-only">Elimina filtro</span>
                </button>
            </div>
            <div
              v-if="presidenti.person"
              id="autocomplete-presidente-form-group"
              @click="autocompleteClicked"
              class="form-group col-lg-12 px-lg-12 py-lg-12">
              <input
                type="search"
                class="autocomplete"
                placeholder="Cerca Presidente"
                id="autocomplete-presidente"
                name="autocomplete-presidente"
                ref="autocompletePresidente"
                :data-autocomplete="JSON.stringify(presidenti.person)">
              <span class="autocomplete-icon" aria-hidden="true">
                <svg class="icon icon-sm align-bottom">
                  <use :xlink:href="icons.itUser"></use>
                </svg>
              </span>
              <label for="autocomplete-presidente" class="sr-only">Cerca i presidenti</label>
            </div>
          </div>
          <div class="form-row">
            <div
              class="chip relatore-bg"
              v-for="(relator, $index) in filters.relators" :key="$index">
                <span class="chip-label text-white"><em>relatore</em>: {{relator}}</span>
                <button @click="deleteFilter('relators', $index)">
                  <svg class="icon white"><use :xlink:href="icons.itClose"></use></svg>
                  <span class="sr-only">Elimina filtro</span>
                </button>
            </div>
            <div
              v-if="relatori.person"
              id="autocomplete-relatori-form-group"
              @click="autocompleteClicked"
              class="form-group col-lg-12 px-lg-12 py-lg-12">
              <input
                type="search"
                class="autocomplete"
                placeholder="Cerca Relatore"
                id="autocomplete-relatore"
                name="autocomplete-relatore"
                ref="autocompleteRelatore"
                :data-autocomplete="JSON.stringify(relatori.person)">
              <span class="autocomplete-icon" aria-hidden="true">
                <svg class="icon icon-sm align-bottom">
                  <use :xlink:href="icons.itUser"></use>
                </svg>
              </span>
              <label for="autocomplete-relatore" class="sr-only">Cerca i relatori</label>
            </div>
          </div>
          <!-- <div class="form-row">
            <div
              v-if="giudici.person"
              id="autocomplete-giudici-form-group"
              @click="autocompleteClicked"
              class="form-group col-lg-12 px-lg-12 py-lg-12">
              <div
              class="chip giudice-bg"
              v-for="(judge, $index) in filters.judges" :key="$index">
                <span class="chip-label text-white"><em>giudice</em>: {{judge}}</span>
                <button @click="deleteFilter('judges', $index)">
                  <svg class="icon white"><use :xlink:href="icons.itClose"></use></svg>
                  <span class="sr-only">Elimina filtro</span>
                </button>
              </div>
              <input
                type="search"
                class="autocomplete"
                placeholder="Cerca Giudice"
                id="autocomplete-giudice"
                name="autocomplete-giudice"
                ref="autocompleteGiudice"
                :data-autocomplete="JSON.stringify(giudici.person)">
              <span class="autocomplete-icon" aria-hidden="true">
                <svg class="icon icon-sm align-bottom">
                  <use :xlink:href="icons.itUser"></use>
                </svg>
              </span>
              <label for="autocomplete-giudice" class="sr-only">Cerca i giudici</label>
            </div>
          </div> -->
        </div>
        <div class="row" v-else>
          <div class="col-lg-12 px-lg-12 py-lg-12">
            <h6 v-if="!presidenti.person && !relatori.person">
              Dammi qualche secondo, sto scaricando dati utili alla ricerca!
            </h6>
            <h6 v-else>
              Ancora un attimo, ci siamo quasi ....
            </h6>
            <Spinner />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import VueSlider from 'vue-slider-component';
import Spinner from '@/components/layout/accessory/Spinner';
import sprites from 'bootstrap-italia/dist/svg/sprite.svg';

import '@/assets/vue-slider-component-theme/bootstrap-italia.css';

function isDescendant(parent, child) {
  let node = child.parentNode;
  while (node != null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}

export default {
  name: 'search-form',
  components: {
    Spinner,
    VueSlider,
  },
  mounted() {
  },
  updated() {
    // eslint-disable-next-line no-undef
    /* $('.it-date-datepicker').datepicker({
      inputFormat: ['yyyy'],
      outputFormat: 'yyyy',
      viewMode: 'years',
      minViewMode: 'years',
      // isDateDisabled: true,
      // isMonthDisabled: true,
    }); */
    if (this.presidenti) {
      // eslint-disable-next-line no-undef
      $(this.$refs.autocompletePresidente).autocomplete();
    }
    if (this.relatori) {
      // eslint-disable-next-line no-undef
      $(this.$refs.autocompleteRelatore).autocomplete();
    }
    if (this.giudici) {
      // eslint-disable-next-line no-undef
      $(this.$refs.autocompleteGiudice).autocomplete();
    }
  },
  methods: {
    deleteFilter(type, index) {
      this.filters[type].splice(index, 1);
    },
    autocompleteClicked(el) {
      el.preventDefault();
      if (el.target.closest('ul.autocomplete-list-show')) {
        if (isDescendant(document.getElementById('autocomplete-presidente-form-group'), el.target)) {
          this.filters.presidents.push(decodeURI(el.target.closest('a').href.split('#')[1]));
        }
        if (isDescendant(document.getElementById('autocomplete-relatori-form-group'), el.target)) {
          this.filters.relators.push(decodeURI(el.target.closest('a').href.split('#')[1]));
        }
        if (isDescendant(document.getElementById('autocomplete-giudici-form-group'), el.target)) {
          this.filters.judges.push(decodeURI(el.target.closest('a').href.split('#')[1]));
        }
        // eslint-disable-next-line no-undef
        $('.autocomplete-list').removeClass('autocomplete-list-show');
        // eslint-disable-next-line no-undef
        $('.autocomplete').val('');
      }
    },
    selectYears() {
      this.filters.years = [];
      const yearsRange = this.$refs.yearsRange.getValue();
      const endYear = yearsRange[1];
      let startYear = yearsRange[0];
      while (startYear <= endYear) {
        this.filters.years.push(startYear);
        startYear += 1;
      }
    },
  },
  // $('.autocomplete').autocomplete();
  computed: mapState(['presidenti', 'relatori', 'giudici']),
  data() {
    return {
      minYear: 1956,
      maxYear: 2019,
      defaultYearsRange: [1956, 2019],
      marks: {
        1956: '1956',
        2019: '2019',
      },
      icons: {
        itFile: `${sprites}#it-file`,
        itUser: `${sprites}#it-user`,
        itExpand: `${sprites}#it-expand`,
        itSearch: `${sprites}#it-search`,
        itClose: `${sprites}#it-close`,
      },
      filters: {
        years: [],
        numbers: [],
        ecli: [],
        presidents: [],
        relators: [],
        judges: [],
      },
    };
  },
};
</script>

<style lang="less" scoped>
  .year-range-wrapper{
    margin-top:10px;
    margin-bottom:50px;
    width:95%!important;
    label{
      margin-left:13px;
    }
  }
  .range-label{
    color: #5c6f82;
    padding-left: 19px;
    min-width: 86px!important;
    width: 100%;
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/accessory/SearchForm.vue